export interface ChangelogEntry {
  id: string;
  date: string;
  title: string;
  description: string;
  category: 'feature' | 'improvement' | 'fix';
  link?: string;
}

// Nombre de jours à afficher (les plus anciennes disparaissent)
export const CHANGELOG_RETENTION_DAYS = 30;

export const CHANGELOG: ChangelogEntry[] = [
  {
    id: "2026-06-10-email-provider-incident",
    date: "2026-06-10",
    title: "Incident email - confirmations non envoyées",
    description: "Le 10 juin, de 10h00 à 23h30, nos emails de confirmation de réservation n'ont pas été envoyés suite à un problème chez notre fournisseur d'email. Les confirmations ont été envoyées manuellement aux clients concernés. Le problème est désormais résolu.",
    category: "fix",
  },
  {
    id: "2026-04-28-table-zones",
    date: "2026-04-28",
    title: "Zones réservables sur les tables",
    description: "Assignez chaque table à une zone (terrasse, salle, bar, etc.) depuis la gestion des tables. Les zones sont héritées automatiquement par les tables combinées lorsque toutes leurs sous-tables partagent la même zone. Idéal pour filtrer et organiser vos tables par espace.",
    category: "feature",
    link: "/dashboard/tables",
  },
  {
    id: "2026-04-28-zone-assignment-fix",
    date: "2026-04-28",
    title: "Correction assignation de zone (tables combinées)",
    description: "Correction d'un bug qui empêchait l'assignation d'une zone à une table appartenant à une combinaison. Les zones se mettent désormais à jour correctement.",
    category: "fix",
    link: "/dashboard/tables",
  },
  {
    id: "2026-03-18-custom-duration",
    date: "2026-03-18",
    title: "Durée personnalisée par créneau horaire",
    description: "Définissez une durée de réservation spécifique pour chaque créneau horaire en mode TIME. Par exemple, 90 min le dimanche au lieu de 105 min par défaut. Configurable depuis la gestion des créneaux.",
    category: "feature",
    link: "/dashboard/time-slots",
  },
  {
    id: "2026-03-18-availability-button",
    date: "2026-03-18",
    title: "Bouton Disponibilité mis à jour",
    description: "Le bouton de recherche de disponibilité a été repensé pour une meilleure lisibilité et accessibilité.",
    category: "improvement",
    link: "/dashboard/availability",
  },
  {
    id: "2026-03-18-walkin-button",
    date: "2026-03-18",
    title: "Bouton Walk-in mis à jour",
    description: "Le bouton walk-in a été mis à jour pour une interface plus cohérente et intuitive.",
    category: "improvement",
  },
  {
    id: "2026-03-15-min-capacity",
    date: "2026-03-15",
    title: "Capacité minimum par table",
    description: "Définissez une capacité minimum sur chaque table individuelle ou combinée. Les réservations ne seront assignées à une table que si le nombre de personnes atteint ce minimum, évitant ainsi de gaspiller les grandes tables pour de petits groupes.",
    category: "feature",
    link: "/dashboard/tables",
  },
  {
    id: "2026-03-15-assignment-priority",
    date: "2026-03-15",
    title: "Ordre de priorité personnalisé des tables",
    description: "Activez l'ordre de priorité personnalisé dans la gestion des tables (vue liste) pour contrôler l'ordre dans lequel les tables sont assignées automatiquement. Les tables avec la priorité la plus basse (1, 2, 3…) sont remplies en premier.",
    category: "feature",
    link: "/dashboard/tables",
  },
  {
    id: "2026-03-09-terrace-management",
    date: "2026-03-09",
    title: "Gestion complète de la terrasse",
    description: "Activez le toggle terrasse dans les réglages de réservation, puis configurez la zone terrasse sur vos tables. Depuis l'onglet Terrasse du dashboard, gérez les fermetures liées à la météo (prévisions 16 jours intégrées), identifiez les réservations impactées et envoyez des notifications email aux clients concernés.",
    category: "feature",
    link: "/dashboard",
  },
  {
    id: "2026-03-09-large-group-contact",
    date: "2026-03-09",
    title: "Choix email ou téléphone pour les grands groupes",
    description: "Les managers peuvent désormais choisir entre un email ou un numéro de téléphone comme méthode de contact pour les grands groupes. Le message affiché aux clients est également personnalisable avec un aperçu en temps réel.",
    category: "improvement",
    link: "/dashboard/establishment",
  },
  {
    id: "2026-02-26-followup-no-consent",
    date: "2026-02-26",
    title: "Email de suivi envoyé à tous les clients arrivés",
    description: "L'email de demande d'avis Google (J+1) est désormais envoyé à tous les clients marqués 'arrivés', sans exiger le consentement marketing. Les clients peuvent toujours se désinscrire via le lien dans l'email.",
    category: "improvement",
  },
  {
    id: "2026-02-21-timeline-table-order",
    date: "2026-02-21",
    title: "Ordre personnalisable des tables dans la Timeline",
    description: "Réorganisez l'ordre des tables dans la vue Timeline grâce aux flèches haut/bas. Votre ordre est sauvegardé automatiquement. Un bouton permet de réinitialiser le tri alphabétique.",
    category: "feature",
    link: "/dashboard",
  },
  {
    id: "2026-02-21-pwa-install",
    date: "2026-02-21",
    title: "Installez Piktable sur votre appareil",
    description: "Piktable peut maintenant être installé comme une application sur votre téléphone ou tablette pour un accès rapide depuis l'écran d'accueil.",
    category: "feature",
  },
  {
    id: "2026-02-19-time-slot-closures",
    date: "2026-02-19",
    title: "Blocage de créneaux par date (Fermetures de service)",
    description: "Bloquez un service précis pour une période de dates, sans fermer tout l'établissement. Par exemple : bloquer uniquement le service du soir le 14 février. Gérable depuis la page \"Gestion des créneaux\".",
    category: "feature",
    link: "/dashboard/time-slots",
  },
  {
    id: "2026-02-17-manager-capacity-bypass",
    date: "2026-02-17",
    title: "Dépassement de capacité pour les managers",
    description: "Les managers peuvent désormais créer et modifier des réservations même si le nombre de personnes dépasse la capacité de la table. Un badge 'Sous-capacité' signale visuellement ces cas.",
    category: "feature",
  },
  {
    id: "2026-02-17-edit-reservation-table-fix",
    date: "2026-02-17",
    title: "Correction changement d'horaire en modification",
    description: "Correction d'un bug où le changement d'horaire d'une réservation pouvait vider la table sélectionnée et provoquer une erreur. La table d'origine est désormais conservée si elle reste disponible.",
    category: "fix",
  },
  {
    id: "2026-02-17-time-mode-availability",
    date: "2026-02-17",
    title: "Horaires disponibles en mode TIME",
    description: "Les créneaux horaires ne sont plus bloqués par la capacité des tables. Un horaire n'apparaît comme complet que si toutes les tables sont réellement réservées.",
    category: "improvement",
  },
  {
    id: "2026-02-17-stroller-fix",
    date: "2026-02-17",
    title: "Correction accueil des poussettes",
    description: "La configuration 'Accueil des poussettes' sur les tables est désormais correctement enregistrée. Auparavant, le réglage revenait toujours à 'activé' après sauvegarde.",
    category: "fix",
  },
  {
    id: "2026-02-17-table-list-toggles",
    date: "2026-02-17",
    title: "Gestion rapide enfants et poussettes en vue liste",
    description: "Les colonnes 'Enfants' et 'Poussettes' sont maintenant disponibles en vue liste dans la gestion des tables, avec des toggles pour modifier rapidement chaque table sans ouvrir le formulaire.",
    category: "feature",
  },
  {
    id: "2026-02-10-marketing-consent",
    date: "2026-02-10",
    title: "Consentement marketing (nLPD)",
    description: "Vos clients peuvent désormais donner leur accord pour recevoir vos offres et actualités directement lors de la réservation. Seuls les clients ayant coché la case recevront des emails marketing (conformité nLPD). Le statut est visible dans la vue Clients.",
    category: "feature",
  },
  {
    id: "2026-02-10-dashboard-list-view",
    date: "2026-02-10",
    title: "Vue liste des réservations",
    description: "Nouveau mode d'affichage sur le dashboard : visualisez toutes vos réservations en liste continue pour un aperçu rapide et complet de votre journée.",
    category: "feature",
  },
  {
    id: "2026-02-04-feedback-system",
    date: "2026-02-04",
    title: "Système de feedback intégré",
    description: "Donnez-nous vos retours facilement ! Cliquez sur 'Donner un feedback' dans les paramètres du dashboard. Bugs, suggestions, questions : chaque envoi nous notifie par email pour un traitement rapide.",
    category: "feature",
  },
  {
    id: "2026-01-30-whats-new",
    date: "2026-01-30",
    title: "Système de notifications des nouveautés",
    description: "Un bouton 'Nouveautés' dans le header vous informe des dernières mises à jour de Piktable avec un point bleu animé.",
    category: "feature",
  },
  {
    id: "2026-01-30-customer-notes",
    date: "2026-01-30",
    title: "Notes clients sur le Dashboard",
    description: "Les notes persistantes des clients (allergies, préférences) sont maintenant visibles directement dans le tableau des réservations avec une icône violette.",
    category: "feature",
  },
  {
    id: "2026-01-30-combined-tables-list",
    date: "2026-01-30",
    title: "Vue liste pour tables combinées",
    description: "Les tables combinées peuvent maintenant être affichées et gérées en mode liste, comme les tables individuelles.",
    category: "improvement",
  },
  {
    id: "2026-01-30-reservation-fix",
    date: "2026-01-30",
    title: "Correction réservations publiques",
    description: "Correction d'un bug où les réservations modifiées (changement de personnes, ajout de notes) étaient parfois rejetées.",
    category: "fix",
  },
];

// Version actuelle du changelog (incrémentée à chaque update)
export const CHANGELOG_VERSION = "2026-06-10-v1";
